import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { getData } from "features/dinamic";

interface AlumnoModuloState {
  status: string;
  error: string;
  modulos: any[];
  activeModulo: any | null;
}

const initialState: AlumnoModuloState = {
  status: 'idle',
  error: '',
  modulos: [],
  activeModulo: null,
}

export const fetchAlumnoModulos = createAsyncThunk('alumno/fetchModulos', async ({ idCiclo, idGrupo }: any, { dispatch, getState, rejectWithValue }) => {
  const idsp = 203;
  const params: any = { idsp, idCiclo };
  if (idGrupo) {
    params.idGrupo = idGrupo;
  }
  const { result, message, data } = await getData(params, getState, dispatch);
  if (result) {
    return { data };
  }
  return rejectWithValue(message);
});

const alumnoModuloSlice = createSlice({
  name: 'alumnoModulo',
  initialState,
  reducers: {
    setActiveModulo: (state, action) => {
      state.activeModulo = action.payload;
    },
    clearModulos: (state) => {
      state.modulos = [];
      state.activeModulo = null;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(fetchAlumnoModulos.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAlumnoModulos.fulfilled, (state, action) => {
        state.status = 'completed';
        state.modulos = Array.isArray(action.payload.data) ? action.payload.data : [];
      })
      .addCase(fetchAlumnoModulos.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as string;
      })
  }
});

export const selectAlumnoModulos = (state: RootState) => state.alumnoModulo.modulos;
export const selectAlumnoModuloActive = (state: RootState) => state.alumnoModulo.activeModulo;
export const selectAlumnoModuloStatus = (state: RootState) => state.alumnoModulo.status;

export const { setActiveModulo, clearModulos } = alumnoModuloSlice.actions;

export default alumnoModuloSlice.reducer;
